import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { withRouter } from "react-router";

import { Modal, notification, Progress } from "antd";
import { CollectionSeeMoreTag } from "./CollectionSeeMoreTag";
import moment from "moment";
import DeleteAsset from "../assets-delete/DeleteAsset";

import DownloadAsset from "../assets-download/DownloadAsset";
import {
  validateComercialTuristik,
  sendNotification,
  getNewPermission,
  getWithDrawer,
  getBreadCrumbs
} from "../../utils/index";
import {
  unsetSelectItem,
  setSelectEditAsset,
  setSelectExpandAsset,
  setSelectShareAsset,
  setSelectItem,
  handleShowNewVersionAsset
} from "../../actions/ClientAction";
import {
  addFavoriteAsset,
  removeFavoriteAsset
} from "../../actions/AssetsFavoritesAction";
import {
  getAdvancedSearchResult,
  getSearchResult
} from "../../actions/SearchAction";
import { getClientsByName } from "../../actions/ClientsAction";
import {
  getImageAssettByExtension,
  KEY_CODE_LEFT,
  KEY_CODE_RIGHT,
  KEY_CODE_ESC,
  SHOW_ONLY_MY_BUNKERS
} from "../../utils";
import {
  setkeyboardEnabled,
  setSelectedFolderExplore,
  searchByTagFromDetail
} from "../../actions/AppAction";
import { showPermission } from "../../actions/PermissionAction";
import { setKeyCollection } from "../../actions/AppAction";
import {
  showComment,
  iconCommentsPrivateNavbar,
  showHideVersions,
  manageListComment,
  setQtyVersions,
  setSelectedItem as commentSelectedItem
} from "../../actions/CommentAction";
import BunkeyAPI from "../../api/BunkeyAPI";
// import './BBMiddlwView.css'
import "./MiddleViewStyles.css";
import CollectionMiddleViewHeader from "./CollectionMiddleViewHeader";
import CollectionMiddleViewAssetAndVersion from "./CollectionMiddleViewAssetAndVersion";
import CollectionMiddleViewAssetInfo from "./CollectionMiddleViewAssetInfo";
import { calculateVersionsQuantity } from "../../utils/index";
import { getAssetById, getCommentsDataByAsset } from "../../api/AssetApi";
import { cleanWasDartUpdated } from "../../actions/MiddleViewAction";
import { getUsersToMention } from "../../actions/CommentAction";
import { individualSelectItem } from "../../actions/IndividualSelectAction";

// import fetchProgress from 'fetch-progress'
export class CollectionMiddleView extends Component {
  constructor(props) {
    super(props);
    this.containerRef = React.createRef();

    this.state = {
      isLoading: true,
      seeMore: false,
      spaceLeft: "-100",
      breadCrumbs: [],
      showDeleteDrawer: false,
      showEditDrawer: false,
      showDownloadDrawer: false,
      isFavorite: false,
      canDownload: true,
      canShare: true,
      canDelete: true,
      canEdit: true,
      canAddFavorite: true,
      canMove: true,
      searchType: "tags",
      canPermissions: true,
      showIconExclamation: false,
      showVersionAsset: false,
      canCommentsAndVersions: false,
      canConvertinator: false,
      canCreateVersionDart: false,
      canViewVersionsDart: false,
      isHover: true,
      description: null,
      statusAsset: null,
      media: [],
      error: null,
      isFetchingAssetData: false,
      isFetchingCommentsData: false,
      assetQtyVersions: 1,
      errorCommentsData: null,
      canBunkeyHost: false,
      canShareLinkBunkeyHost: false
    };
  }

  componentDidMount() {
    const {
      itemSelected,
      user,
      keyCollection,
      modules,
      workclient,
      newMatrix,
      getUsersToMention
    } = this.props;

    this.handleGetPathItem();
    this.handleValidProfile();
    this.handleActionsPublicShareAsset();
    this.handleIsFavoriteAsset();
    setTimeout(() => {
      this.handleGetArrowPosition();
      this.handleScrollTo();
    }, 300);

    if (keyCollection === "assetsPublicShared") {
      this.setState({
        canDownload: true,
        canShare: false,
        canDelete: false,
        canEdit: false,
        canAddFavorite: false,
        canMove: false,
        canPermissions: false,
        canCommentsAndVersions: false,
        canCreateVersionDart: false,
        canViewVersionsDart: false,
        canBunkeyHost: false,
        canShareLinkBunkeyHost: false
      });
    } else if (
      user.clientRole === "admin" &&
      user.role === "admin" &&
      (user.email === "jorge@bunkey.tv" ||
        user.email === "victor@bunkey.tv" ||
        user.email === "ricardo.melo@bunkey.tv" ||
        user.email === "sebastian.grob@bunkey.tv" ||
        user.email === "douglas@bunkey.tv")
    ) {
      this.setState({
        canConvertinator: true,
        canCreateVersionDart: true,
        canViewVersionsDart: true
      });
    } else if (user.clientRole !== "admin" && user.role !== "admin") {
      this.setState({
        canEdit: getNewPermission(itemSelected._id, newMatrix, "edit"),
        canDownload: getNewPermission(itemSelected._id, newMatrix, "download"),
        canDelete: getNewPermission(itemSelected._id, newMatrix, "delete"),
        canShare: getNewPermission(itemSelected._id, newMatrix, "share"),
        canMove: getNewPermission(itemSelected._id, newMatrix, "move"),
        canCreateVersionDart: getNewPermission(
          itemSelected,
          newMatrix,
          "createVersionDart"
        ),
        canViewVersionsDart: getNewPermission(
          itemSelected,
          newMatrix,
          "viewVersionsDart"
        ),
        canShareLinkBunkeyHost: getNewPermission(
          itemSelected,
          newMatrix,
          "bunkeyHost"
        )
      });
    }
    if (
      itemSelected.rightsState === "expired" ||
      moment().format("YYYY-MM-DD") >
        moment(itemSelected.metadata.dueDate)
          .utc()
          .format("YYYY-MM-DD") ||
      (moment(itemSelected.metadata.createdDate)
        .utc()
        .format("YYYY-MM-DD") > moment().format("YYYY-MM-DD") &&
        moment().format("YYYY-MM-DD") <
          moment(itemSelected.metadata.dueDate)
            .utc()
            .format("YYYY-MM-DD"))
    ) {
      if (
        itemSelected.metadata.createdDate !== null &&
        itemSelected.metadata.createdDate !== ""
      ) {
        this.setState({
          showIconExclamation: true
        });
      } else {
        this.setState({
          showIconExclamation: false
        });
      }
    }

    if (modules && keyCollection !== "assetsPublicShared") {
      let finalPermissions = {};
      modules.forEach(module => {
        if (module.name === "commentsAndVersions") {
          finalPermissions.canCommentsAndVersions =
            user.clientRole === "admin" ||
            user.role === "admin" ||
            (module.activate &&
              (getNewPermission(
                itemSelected._id,
                newMatrix,
                "createVersionDart"
              ) ||
                getNewPermission(
                  itemSelected._id,
                  newMatrix,
                  "viewVersionsDart"
                ) ||
                getNewPermission(
                  itemSelected._id,
                  newMatrix,
                  "createCommentDart"
                )));
          finalPermissions.canCreateVersionDart =
            user.clientRole === "admin" ||
            user.role === "admin" ||
            getNewPermission(itemSelected._id, newMatrix, "createVersionDart");
          finalPermissions.canViewVersionsDart =
            user.clientRole === "admin" ||
            user.role === "admin" ||
            getNewPermission(itemSelected._id, newMatrix, "viewVersionsDart");
        }
        if (module.name === "BunkeyHost") {
          finalPermissions.canBunkeyHost =
            user.clientRole === "admin" ||
            user.role === "admin" ||
            module.activate;
          finalPermissions.canShareLinkBunkeyHost =
            user.clientRole === "admin" ||
            user.role === "admin" ||
            getNewPermission(itemSelected._id, newMatrix, "bunkeyHost");
        }
      });
      this.setState(finalPermissions);
    }

    if (SHOW_ONLY_MY_BUNKERS.includes(workclient)) {
      this.setState({ canAddFavorite: false });
    }

    if (itemSelected && workclient) {
      this.startFetchingAssetData();
      this.startFetchingCommentsData();
      //Obtenemos los usuarios
      getUsersToMention(itemSelected._id);
    }
  }

  componentDidUpdate(prevProps) {
    const {
      itemSelected,
      favoriteAssets,
      isMoved,
      intl,
      newMatrix,
      user,
      keyCollection,
      getUsersToMention,
      workclient
    } = this.props;
    if (prevProps.itemSelected._id !== itemSelected._id) {
      this.setState({ isLoading: true }, () => this.handleGetArrowPosition());
      this.handleGetPathItem();
      this.handleIsFavoriteAsset();
    }
    if (prevProps.favoriteAssets !== favoriteAssets) {
      this.handleIsFavoriteAsset();
    }

    if (
      !itemSelected.isMoveSelected &&
      itemSelected !== prevProps.itemSelected &&
      isMoved
    ) {
      sendNotification(
        "success",
        intl,
        intl.formatMessage({ id: "asset_has_been_moved" })
      );
    }

    if (prevProps.favoriteAssets < favoriteAssets) {
      sendNotification(
        "info",
        intl,
        intl.formatMessage({ id: "added_to_favorites" })
      );
    } else if (prevProps.favoriteAssets > favoriteAssets) {
      sendNotification(
        "info",
        intl,
        intl.formatMessage({ id: "delete_from_favorites" })
      );
    }

    if (prevProps.itemSelected !== itemSelected) {
      let refreshPermission = {};
      if (keyCollection === "assetsPublicShared") {
        refreshPermission = {
          canDownload: true,
          canShare: false,
          canDelete: false,
          canEdit: false,
          canAddFavorite: false,
          canMove: false,
          canPermissions: false,
          canCommentsAndVersions: false,
          canCreateVersionDart: false,
          canViewVersionsDart: false,
          canBunkeyHost: false,
          canShareLinkBunkeyHost: false
        };
      } else {
        refreshPermission = {
          canEdit:
            user.clientRole === "admin" ||
            user.role === "admin" ||
            getNewPermission(itemSelected._id, newMatrix, "edit"),
          canDownload:
            user.clientRole === "admin" ||
            user.role === "admin" ||
            getNewPermission(itemSelected._id, newMatrix, "download"),
          canDelete:
            user.clientRole === "admin" ||
            user.role === "admin" ||
            getNewPermission(itemSelected._id, newMatrix, "delete"),
          canShare:
            user.clientRole === "admin" ||
            user.role === "admin" ||
            getNewPermission(itemSelected._id, newMatrix, "share"),
          canMove:
            user.clientRole === "admin" ||
            user.role === "admin" ||
            getNewPermission(itemSelected._id, newMatrix, "move"),
          canCreateVersionDart:
            user.clientRole === "admin" ||
            user.role === "admin" ||
            getNewPermission(itemSelected._id, newMatrix, "createVersionDart"),
          canViewVersionsDart:
            user.clientRole === "admin" ||
            user.role === "admin" ||
            getNewPermission(itemSelected._id, newMatrix, "viewVersionsDart"),
          canShareLinkBunkeyHost:
            user.clientRole === "admin" ||
            user.role === "admin" ||
            getNewPermission(itemSelected._id, newMatrix, "bunkeyHost")
        };
      }

      if (
        itemSelected.rightsState === "expired" ||
        (moment().format("YYYY-MM-DD") >
          moment(itemSelected.metadata.dueDate)
            .utc()
            .format("YYYY-MM-DD") &&
          itemSelected.metadata.createdDate !== null &&
          itemSelected.metadata.createdDate !== "")
      ) {
        this.setState({
          showIconExclamation: true,
          ...refreshPermission
        });
      } else {
        this.setState({
          showIconExclamation: false,
          ...refreshPermission
        });
      }
      if (
        moment(itemSelected.metadata.createdDate)
          .utc()
          .format("YYYY-MM-DD") > moment().format("YYYY-MM-DD") &&
        moment().format("YYYY-MM-DD") <
          moment(itemSelected.metadata.dueDate)
            .utc()
            .format("YYYY-MM-DD") &&
        itemSelected.metadata.createdDate !== null &&
        itemSelected.metadata.createdDate !== ""
      ) {
        this.setState({
          showIconExclamation: true,
          ...refreshPermission
        });
      }

      this.startFetchingAssetData();
      this.startFetchingCommentsData();

      //Obtenemos los usuarios
      if (itemSelected && workclient) getUsersToMention(itemSelected._id);
    }

    if (
      this.props.wasDartUpdated &&
      prevProps.wasDartUpdated !== this.props.wasDartUpdated &&
      this.props.updatedAssetId === itemSelected._id
    ) {
      this.props.cleanWasDartUpdated().then(() => {
        this.startFetchingAssetData();
        this.startFetchingCommentsData();
      });
    }
    if (
      this.props.wasDartUpdated &&
      prevProps.wasDartUpdated === this.props.wasDartUpdated
    ) {
      this.props.cleanWasDartUpdated();
    }
  }

  handleKeyPress = e => {
    const { keyCollection, isDartOpen } = this.props;
    const { isHover } = this.state;
    if (!isDartOpen && isHover) {
      switch (e.keyCode) {
        case KEY_CODE_LEFT:
          this.handleOnPrev();
          break;
        case KEY_CODE_RIGHT:
          this.handleOnNext();
          break;
        case KEY_CODE_ESC:
          this.props.unsetSelectItem(keyCollection);
          break;
        default:
          break;
      }
    }
  };

  handleSeeMore = () => {
    this.setState({
      seeMore: true
    });
  };

  handleValidProfile = () => {
    const { keyCollection } = this.props;
    if (keyCollection !== "assetsPublicShared") {
      const isValid = validateComercialTuristik();
      this.setState({
        canDownload: isValid,
        canShare: isValid,
        canDelete: isValid
      });
    }
  };

  handleActionsPublicShareAsset = () => {
    const { keyCollection } = this.props;
    if (keyCollection === "assetsPublicShared") {
      this.setState({
        canDownload: true,
        canShare: false,
        canDelete: false,
        canEdit: false,
        canAddFavorite: false,
        canMove: false,
        canPermissions: false
      });
    }
  };

  handleGetArrowPosition = () => {
    const {
      itemSelected,
      from,
      width,
      verticalCount,
      horizontalCount
    } = this.props;

    let i =
      itemSelected && itemSelected.indice
        ? itemSelected.indice.replace(`${from}-`, "")
        : "";
    let position = 0;
    let widthVertical = -100;
    let widthHorizontal = -100;

    if (width <= 320) {
      widthHorizontal = 290;
      widthVertical = 284;
    } else if (width > 320 && width <= 375) {
      widthHorizontal = 345;
      widthVertical = 338;
    } else if (width > 375 && width <= 425) {
      widthHorizontal = 395;
      widthVertical = 387;
    } else if (width > 425 && width <= 768) {
      widthHorizontal = -100;
      widthVertical = 230;
    } else if (width > 768 && width <= 1024) {
      widthHorizontal = -100;
      widthVertical = 178;
    } else if (width > 1024 && width <= 1440) {
      widthHorizontal = -100;
      widthVertical = 218;
    }

    if (from === "vertical") {
      for (let index = 1; index <= i; index++) {
        if (position >= verticalCount) {
          position = 1;
        } else {
          position++;
        }
      }
      let space = widthVertical * position - widthVertical / 2;
      this.setState({
        spaceLeft: space,
        isLoading: false
      });
    } else {
      for (let index = 1; index <= i; index++) {
        if (position >= horizontalCount) {
          position = 1;
        } else {
          position++;
        }
      }
      let space = widthHorizontal * position - widthHorizontal / 2;
      this.setState({
        spaceLeft: space,
        isLoading: false
      });
    }
  };

  handleScrollTo = () => {
    const { keyCollection, activeView } = this.props;
    if (this.containerRef && this.containerRef.current) {
      let calc = this.offset(this.containerRef.current);
      if (keyCollection !== "assetsExplore") {
        window.scroll({ top: calc.top - 110, left: 0, behavior: "smooth" });
      } else {
        if (activeView === "vertical") {
          const parentRect = document
            .getElementsByClassName("bb-box-edit__content")
            .item(0)
            .getBoundingClientRect().top;
          const childRect = document.getElementById("scrollableDivVertical")
            .scrollTop;
          document.getElementById("scrollableDivVertical").scrollTo({
            top: parentRect + childRect - 110,
            behavior: "smooth"
          });
          document
            .getElementsByClassName("bb-box-edit__content")
            .item(0)
            .scrollIntoView({
              behavior: "smooth",
              block: "center",
              inline: "start"
            });
        }
        if (activeView === "list") {
          const parentRect = document
            .getElementsByClassName("bb-box-edit__content")
            .item(0)
            .getBoundingClientRect().top;
          const childRect = document.getElementById("scrollableDivList")
            .scrollTop;
          document.getElementById("scrollableDivList").scrollTo({
            top: parentRect + childRect - 110,
            behavior: "smooth"
          });
          document
            .getElementsByClassName("bb-box-edit__content")
            .item(0)
            .scrollIntoView({
              behavior: "smooth",
              block: "center",
              inline: "start"
            });
        }
      }
    }
  };
  offset = el => {
    var rect = el.getBoundingClientRect(),
      scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
      scrollTop = window.pageYOffset;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
  };

  handleGetPathItem = () => {
    const { folderselect } = this.props;
    this.setState({
      breadCrumbs: getBreadCrumbs(folderselect)
    });
  };

  handleShowDeleteDrawer = itemSelected => {
    const { keyCollection } = this.props;
    this.props.individualSelectItem(itemSelected, "delete", keyCollection);
  };

  handleHideDeleteDrawer = () => {
    this.setState(
      {
        showDeleteDrawer: false
      },
      () => this.props.setkeyboardEnabled(false)
    );
  };

  handleEditDrawer = () => {
    this.setState({
      showEditDrawer: true
    });
  };

  handleHideEditDrawer = () => {
    this.setState({
      showEditDrawer: false
    });
  };

  handleShowDownloadDrawer = () => {
    this.setState({
      showDownloadDrawer: true
    });
  };

  handleHideDownloadDrawer = () => {
    this.setState({
      showDownloadDrawer: false
    });
    this.props.setkeyboardEnabled(false);
  };

  handleIsFavoriteAsset = () => {
    const { itemSelected, favoriteAssets } = this.props;
    const isFavorite = favoriteAssets.find(r => r._id === itemSelected._id);
    this.setState({ isFavorite });
  };

  handleOnPrev = () => {
    const { keyCollection, intl, from, handlerSelectFlickity } = this.props;
    const prev = this.handlePrevNextItem("prev");
    if (prev) {
      this.props.setSelectItem(keyCollection, prev, prev.from, prev.indice);
      if (from === "horizontal") {
        const previousIndexFlickity = this.getFlickityIndex(prev.indice);
        handlerSelectFlickity(previousIndexFlickity);
      }
    } else {
      sendNotification(
        "info",
        intl,
        intl.formatMessage({ id: "first_record" })
      );
    }
  };

  handleOnNext = () => {
    const { keyCollection, intl, from, handlerSelectFlickity } = this.props;
    const next = this.handlePrevNextItem("next");
    if (next) {
      this.props.setSelectItem(keyCollection, next, next.from, next.indice);
      if (from === "horizontal") {
        const nextIndexFlickity = this.getFlickityIndex(next.indice);
        handlerSelectFlickity(nextIndexFlickity);
      }
    } else {
      sendNotification("info", intl, intl.formatMessage({ id: "last_record" }));
    }
  };

  handlePrevNextItem = type => {
    const { data, itemSelected } = this.props;
    const preData = data.map((r, k) => {
      let x = k + 1;
      return {
        ...r,
        from: r.from ? r.from : itemSelected.from,
        indice: r.indice ? r.indice : `${itemSelected.from}-${x}`
      };
    });
    const dataValid = preData.filter(
      r => r.type !== "folder" && r.type !== "bunker"
    );
    let prev = -1;
    let next = -1;

    if (!dataValid || dataValid.length === 0) return;
    dataValid.forEach((item, index) => {
      if (item.isSelected) {
        prev = index - 1;
        next = index + 1;
      }
    });

    let futureItem = dataValid[type === "prev" ? prev : next];
    if (!futureItem) {
      if (type === "prev") {
        futureItem = dataValid.pop();
      } else {
        futureItem = dataValid[0];
      }
    }
    return futureItem;
  };

  handleTagSearch = r => {
    const { workclient } = this.props;

    if (workclient) {
      // Enruta por el buscador avanzado poniendo el tag en el filtro de Tags (y limpiando
      // el Nombre) para que el panel de filtros refleje qué se está buscando. Antes se
      // llamaba a getAdvancedSearchResult directo con `tags=r`: la búsqueda salía bien pero
      // el panel avanzado quedaba con la búsqueda por nombre anterior y el Tags vacío.
      this.props.searchByTagFromDetail(r);
    } else {
      this.props.getClientsByName(1, r);
    }
  };

  handleShowMessage = (event, focusDescription) => {
    const { itemSelected, keyCollection } = this.props;
    this.props.showComment(itemSelected, keyCollection, focusDescription);
    this.props.iconCommentsPrivateNavbar(false);
    this.props.manageListComment(false);
  };

  handleShowVersions = () => {
    const { itemSelected, keyCollection } = this.props;
    this.props.showComment(itemSelected, keyCollection);
    this.props.iconCommentsPrivateNavbar(false);
    this.props.manageListComment(false);
    this.props.showHideVersions();
  };

  handleShowNewVersion = () => {
    this.setState({
      showVersionAsset: true
    });
  };

  handleHideNewVersion = () => {
    this.setState({
      showVersionAsset: false
    });
  };

  handleSetSrc = r => {
    const { originalURL, mediaQualityURL } = r;
    const itemUrl =
      originalURL !== mediaQualityURL
        ? mediaQualityURL
        : getImageAssettByExtension(r.originalURL);
    return itemUrl;
  };

  handleForceConversion = () => {
    const { itemSelected, intl } = this.props;
    if (itemSelected) {
      BunkeyAPI({
        url: `/convertinators`,
        method: "POST",
        data: {
          id: itemSelected._id
        }
      })
        .then(resp => {
          if (resp.status === 201)
            sendNotification(
              "success",
              intl,
              intl.formatMessage({
                id: "convetinator_force_conversion_success"
              })
            );
          else
            sendNotification(
              "error",
              intl,
              intl.formatMessage({ id: "error_message" })
            );
        })
        .catch(e => {
          sendNotification(
            "error",
            intl,
            intl.formatMessage({ id: "error_message" })
          );
        });
    }
  };
  getFlickityIndex = indice => {
    try {
      return Number(indice.split("-")[1]) - 1;
    } catch (err) {
      return 0;
    }
  };

  setIsHover = isHover => {
    this.setState(state => {
      return {
        ...state,
        isHover: isHover
      };
    });
  };

  setDataAsset = data => {
    const { itemSelected, keyCollection } = this.props;
    if (keyCollection === "assetsLastUploads" || keyCollection === "searcher") {
      /**
       * Si es la coleccion de ultimas subidas o buscador, obtiene breadCrumbs y lo setea en el estado
       */
      const { _id, description, statusAsset, media, parents } = data[0];
      if (_id === itemSelected._id) {
        this.setState({
          description: description,
          statusAsset: statusAsset,
          media: media,
          isFetchingAssetData: false,
          breadCrumbs: parents.map(r => {
            return {
              name: r.name,
              id: r._id
            };
          })
        });
      }
    } else {
      const { _id, description, statusAsset, media } = data[0];
      if (_id === itemSelected._id) {
        this.setState({
          description: description,
          statusAsset: statusAsset,
          media: media,
          isFetchingAssetData: false
        });
      }
    }
  };

  setDataAssetError = err => {
    this.setState({
      description: null,
      statusASset: null,
      media: [],
      error: err,
      isFetchingAssetData: false
    });
  };

  setCommentsData = data => {
    const { itemSelected } = this.props;

    const totalVersions = calculateVersionsQuantity(
      data.versions,
      data.document
    );
    if (itemSelected._id === data.document._id) {
      this.setState({
        isFetchingCommentsData: false,
        errorCommentsData: null,
        assetQtyVersions: totalVersions
      });
    }
  };

  setCommentsDataError = err => {
    this.setState({
      isFetchingCommentsData: false,
      errorCommentsData: err,
      assetQtyVersions: 1
    });
  };

  startFetchingAssetData = () => {
    const { keyCollection } = this.props;
    if (keyCollection !== "assetsPublicShared") {
      this.setState(
        {
          isFetchingAssetData: true
        },
        this.fetchAssetData()
      );
    }
  };

  fetchAssetData = () => {
    const { workclient, itemSelected } = this.props;

    getAssetById(workclient, itemSelected._id)
      .then(res => {
        this.setDataAsset(res.data);
      })
      .catch(err => this.setDataAssetError(err));
  };

  fetchCommentsData = () => {
    const { workclient, itemSelected } = this.props;
    getCommentsDataByAsset(workclient, itemSelected._id)
      .then(res => {
        this.setCommentsData(res.data);
      })
      .catch(err => this.setCommentsDataError(err));
  };

  startFetchingCommentsData = () => {
    const { keyCollection } = this.props;
    if (keyCollection !== "assetsPublicShared") {
      this.setState(
        {
          isFetchingCommentsData: true
        },
        this.fetchCommentsData()
      );
    }
  };

  expandAsset = (keyCollection, itemSelected) => {
    const { originalURL, type, name } = itemSelected;
    const { intl } = this.props;
    const now = Date.now();
    const confinNotf = {
      message: intl.formatMessage({ id: "opening_pdf" }),
      description: <Progress percent={100} status="active" />,
      key: now.toString()
    };
    if (originalURL) {
      const ext =
        originalURL
          .split(".")
          .slice(-1)[0]
          .toLowerCase() || null;
      if (ext && ext === "pdf" && type === "document") {
        notification.open(confinNotf);
        fetch(originalURL)
          .then(res => res.blob())
          .then(blob => {
            const newBlob = blob.slice(0, blob.size, "application/pdf");
            const objectURL = URL.createObjectURL(newBlob);
            window.open(objectURL, name, "_blank");
            notification.close(now.toString());
          });
      } else this.props.setSelectExpandAsset(keyCollection, itemSelected);
    }
  };

  handleSelectFolderExplore = id => {
    if (id) {
      this.props.setSelectedFolderExplore(id);
    } else {
      this.props.setSelectedFolderExplore(null);
    }
  };

  render() {
    const {
      seeMore,
      spaceLeft,
      breadCrumbs,
      showDeleteDrawer,
      showDownloadDrawer,
      canDownload,
      canShare,
      canDelete,
      canEdit,
      canAddFavorite,
      canMove,
      isFavorite,
      isLoading,
      canPermissions,
      showIconExclamation,
      canCommentsAndVersions,
      canConvertinator,
      canCreateVersionDart,
      canViewVersionsDart,
      description,
      isFetchingAssetData,
      media,
      statusAsset,
      assetQtyVersions,
      isFetchingCommentsData,
      canBunkeyHost,
      canShareLinkBunkeyHost
    } = this.state;
    const {
      itemSelected,
      keyCollection,
      workclient,
      workspace,
      from,
      intl,
      handleShowNewVersionAsset,
      width,
      dartCustomField,
      clientMedia,
      data
    } = this.props;

    const tabEdit = "edit";
    const tabMove = "move";
    return (
      <React.Fragment>
        <div>
          {/* Este div esta vacio por que al cargar muestra su contenido */}
          {isLoading && <div> </div>}

          {from === "vertical" && spaceLeft > 0 && (
            <div className="arrow-wrapper-middleview">
              <div className="container">
                <div
                  className="arrow-middleview"
                  style={{ left: `${spaceLeft}px` }}
                ></div>
              </div>
            </div>
          )}

          {itemSelected && !isLoading && (
            <div className="bb-box-edit">
              <div className="bb-box-edit__content" ref={this.containerRef}>
                <CollectionMiddleViewHeader
                  workClient={workclient}
                  itemSelected={itemSelected}
                  breadCrumbs={breadCrumbs}
                  prevAssetMessage={intl.formatMessage({ id: "prev_asset" })}
                  nextAssetMessage={intl.formatMessage({ id: "next_asset" })}
                  handleOnPrev={this.handleOnPrev}
                  handleOnNext={this.handleOnNext}
                  handleUnselectedItem={() =>
                    this.props.unsetSelectItem(keyCollection)
                  }
                  currentViewWidth={width}
                  data={data}
                  handleSelectFolderExplore={this.handleSelectFolderExplore}
                />
                {/*FIN DIV TITLE */}

                <CollectionMiddleViewAssetAndVersion
                  itemSelected={itemSelected}
                  handleSetSrc={this.handleSetSrc}
                  breadCrumbs={breadCrumbs}
                  keyCollection={keyCollection}
                  from={from}
                  canCommentsAndVersions={canCommentsAndVersions}
                  description={description}
                  isFetchingAssetData={isFetchingAssetData}
                  canCreateVersionDart={canCreateVersionDart}
                  canViewVersionsDart={canViewVersionsDart}
                  handleShowVersions={this.handleShowVersions}
                  handleShowMessage={this.handleShowMessage}
                  handleShowNewVersionAsset={() => {
                    handleShowNewVersionAsset({
                      itemSelected: {
                        document: itemSelected,
                        userCreator: itemSelected.user,
                        versions: []
                      },
                      breadCrumbs,
                      keyCollection,
                      from
                    });
                  }}
                  statusAsset={statusAsset}
                  qtyVersions={assetQtyVersions}
                  itemSelectedFetching={isFetchingCommentsData}
                  handleSelectExpandAsset={() =>
                    this.expandAsset(keyCollection, itemSelected)
                  }
                  workclient={workclient}
                  user={this.props.user}
                  modules={this.props.modules}
                />
                <div id="middleview_ref"></div>
                {/*FIN DIv c-box-edit__thumb*/}

                <CollectionMiddleViewAssetInfo
                  workclient={workclient}
                  itemSelected={itemSelected}
                  keyCollection={keyCollection}
                  handleTagSearch={this.handleTagSearch}
                  handleSeeMore={this.handleSeeMore}
                  canShare={canShare}
                  canDelete={canDelete}
                  canEdit={canEdit}
                  canAddFavorite={canAddFavorite}
                  canMove={canMove}
                  isFavorite={isFavorite}
                  canDownload={canDownload}
                  canCommentsAndVersions={canCommentsAndVersions}
                  canPermissions={canPermissions}
                  canConvertinator={canConvertinator}
                  hadleEdit={() =>
                    this.props.setSelectEditAsset(
                      keyCollection,
                      itemSelected,
                      tabEdit
                    )
                  }
                  handleShare={() =>
                    this.props.setSelectShareAsset(keyCollection, itemSelected)
                  }
                  handleAddFavorite={() =>
                    this.props.addFavoriteAsset(
                      workclient,
                      workspace,
                      itemSelected
                    )
                  }
                  handleRemoveFavorite={() =>
                    this.props.removeFavoriteAsset(
                      workclient,
                      workspace,
                      itemSelected
                    )
                  }
                  handleSelectExpandAsset={() =>
                    this.expandAsset(keyCollection, itemSelected)
                  }
                  handleShowDownloadDrawer={this.handleShowDownloadDrawer}
                  handleShowDeleteDrawer={this.handleShowDeleteDrawer}
                  handleShowMoveDrawer={() => {
                    this.props.setSelectEditAsset(
                      keyCollection,
                      itemSelected,
                      tabMove
                    );
                    // this.props.individualSelectItem(
                    //   itemSelected,
                    //   "move",
                    //   keyCollection
                    // )
                  }} // Se envia parametro "tabMove" para que el drawer abra en la pestaña correspondiente al icono
                  handleShowMessage={this.handleShowMessage}
                  handleForceConversion={this.handleForceConversion}
                  handleShowPermission={() => {
                    this.props.setKeyCollection(keyCollection);
                    this.props.showPermission(itemSelected);
                  }}
                  showIconExclamation={showIconExclamation}
                  media={media}
                  isFetchingAssetData={isFetchingAssetData}
                  dartCustomField={dartCustomField}
                  clientMedia={clientMedia}
                  canBunkeyHost={canBunkeyHost}
                  canShareLinkBunkeyHost={canShareLinkBunkeyHost}
                />
                {/*FIN c-box-edit__info */}
              </div>
            </div>
          )}
        </div>
        {/* AQUI TERMINA NUEVA IMPLEMENTACION */}
        {/* Este div esta vacio por que al cargar muestra su contenido */}

        <Modal
          title="Tags"
          placement="right"
          closable={true}
          footer={null}
          onCancel={() => {
            this.setState({ seeMore: false });
          }}
          onClose={() => {
            this.setState({ seeMore: false });
          }}
          visible={seeMore}
        >
          {itemSelected && (
            <CollectionSeeMoreTag
              data={itemSelected.metadata.descriptiveTags}
            />
          )}
        </Modal>
        <Modal
          title={intl.formatMessage({ id: "delete_asset" })}
          width={getWithDrawer()}
          closable={true}
          footer={null}
          onCancel={this.handleHideDeleteDrawer}
          onClose={this.handleHideDeleteDrawer}
          destroyOnClose={true}
          visible={showDeleteDrawer}
        >
          <DeleteAsset
            itemSelected={itemSelected}
            handleHideDeleteDrawer={this.handleHideDeleteDrawer}
            keyCollection={keyCollection}
          />
        </Modal>
        <Modal
          title={intl.formatMessage({ id: "download_asset" })}
          closable={true}
          footer={null}
          width={getWithDrawer()}
          destroyOnClose={true}
          onCancel={this.handleHideDownloadDrawer}
          onClose={this.handleHideDownloadDrawer}
          visible={showDownloadDrawer}
        >
          <DownloadAsset
            itemSelected={itemSelected}
            handleHideDownloadDrawer={this.handleHideDownloadDrawer}
            showIconExclamation={showIconExclamation}
          />
        </Modal>
        {/* <Drawer
          title={<span style={{ color: '#909090' }}>
            {intl.formatMessage({ id: "upload_new_version" })}
          </span>}
          closable={true}
          width={getWithDrawer()}
          destroyOnClose={!isUploading}
          headerStyle={{ backgroundColor: '#1F1F22', borderBottom: '1px solid #909090', color: '#FF0000' }}
          drawerStyle={{ backgroundColor: '#1F1F22', color: '#909090 !important' }}
          onClose={this.handleHideNewVersion}
          visible={showVersionAsset}
        >
          <VersionAsset
            theme={`dark`}
            itemSelected={{
              document: itemSelected,
              userCreator: itemSelected.user,
              versions: []
            }}
            breadCrumbs={breadCrumbs}
            handleHideNewVersion={this.handleHideNewVersion}
            keyCollection={keyCollection}
            from={from}
          />
        </Drawer> */}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { keyCollection } = ownProps;
  let object;
  switch (keyCollection) {
    case "assetsRoot":
      object = {
        isFetching: state.assetsRoot.isFetching,
        data: state.assetsRoot.data,
        itemSelected: state.assetsRoot.data.find(r => r.isSelected),
        folderselect: state.assetsRoot.folderselect,
        error: state.assetsRoot.error,
        activeView: state.assetsRoot.activeView,
        itemEditSelected: state.assetsRoot.data.find(r => r.isEditSelected),
        keyboardEnable: state.app.keyboardEnable
      };
      break;
    case "assetsLastUploads":
      object = {
        isFetching: state.assetsLastUploads.isFetching,
        data: state.assetsLastUploads.data,
        itemSelected: state.assetsLastUploads.data.find(r => r.isSelected),
        folderselect: state.assetsLastUploads.folderselect,
        error: state.assetsLastUploads.error,
        activeView: state.assetsLastUploads.activeView,
        keyboardEnable: state.app.keyboardEnable
      };
      break;
    case "assetsShared":
      object = {
        isFetching: state.assetsShared.isFetching,
        data: state.assetsShared.data,
        itemSelected: state.assetsShared.data.find(r => r.isSelected),
        folderselect: state.assetsShared.folderselect,
        error: state.assetsShared.error,
        activeView: state.assetsShared.activeView,
        keyboardEnable: state.app.keyboardEnable
      };
      break;
    case "assetsFavorites":
      object = {
        isFetching: state.assetsFavorites.isFetching,
        data: state.assetsFavorites.data,
        itemSelected: state.assetsFavorites.data.find(r => r.isSelected),
        folderselect: state.assetsFavorites.folderselect,
        error: state.assetsFavorites.error,
        activeView: state.assetsFavorites.activeView,
        keyboardEnable: state.app.keyboardEnable
      };
      break;
    // El Gestor de Derechos de Uso reusa este mismo panel para ver la pieza.
    // Su slice tiene el contrato de siempre: `data` con el elegido marcado.
    case "rightsManager":
      object = {
        isFetching: state.rights.viewer.isFetching,
        data: state.rights.viewer.data,
        itemSelected: state.rights.viewer.data.find(r => r.isSelected),
        folderselect: state.rights.viewer.folderselect,
        error: state.rights.viewer.error,
        activeView: "grid",
        keyboardEnable: state.app.keyboardEnable
      };
      break;
    case "assetsExplore":
      object = {
        isFetching: state.assetsExplore.isFetching,
        data: state.assetsExplore.data,
        itemSelected: state.assetsExplore.data.find(r => r.isSelected),
        folderselect: state.assetsExplore.folderselect,
        error: state.assetsExplore.error,
        activeView: state.assetsExplore.activeView,
        keyboardEnable: state.app.keyboardEnable
      };
      break;
    case "searcher":
      object = {
        isFetching: state.searcher.isFetching,
        data: state.searcher.data,
        itemSelected: state.searcher.data.find(r => r.isSelected),
        folderselect: state.searcher.folderselect,
        error: state.searcher.error,
        searchText: state.searcher.searchText,
        activeView: state.searcher.activeView,
        keyboardEnable: state.app.keyboardEnable
      };
      break;
    case "assetsPublicShared":
      object = {
        isFetching: state.assetsPublicShared.isFetching,
        data: state.assetsPublicShared.data,
        itemSelected: state.assetsPublicShared.data.find(r => r.isSelected),
        folderselect: state.assetsPublicShared.folderselect,
        error: state.assetsPublicShared.error,
        searchText: state.assetsPublicShared.searchText,
        activeView: state.assetsPublicShared.activeView,
        keyboardEnable: state.app.keyboardEnable
      };
      break;

    default:
      object = {};
      break;
  }
  return {
    ...object,
    root: state.client.root,
    newColor:
      state.authUser.user && state.authUser.user.color
        ? state.authUser.user.color
        : "#2E97CF",
    searchText: state.searcher.searchText,
    workspace: state.assetsFavorites.workspace,
    workclient: state.client.workclient,
    modules: state.client.data ? state.client.data.modules : [],
    favoriteAssets: state.assetsFavorites.data,
    width: state.app.width,
    verticalCount: state.app.verticalCount,
    horizontalCount: state.app.horizontalCount,
    breadcrumb: state.client.breadcrumb,
    user: state.authUser.user,
    isDownloading: state.downloads.isDownloading,
    newMatrix: state.group.newMatrix,
    isDartOpen: state.comments.show,
    dartCustomField: state.client.data ? state.client.data.dartCustomField : [],
    wasDartUpdated: state.middleView.wasDartUpdated,
    updatedAssetId: state.middleView.updatedAssetId,
    clientMedia: state.client.data ? state.client.data.media : null
  };
};

const mapDispatchToProps = {
  getClientsByName,
  getSearchResult,
  getAdvancedSearchResult,
  searchByTagFromDetail,
  unsetSelectItem,
  setSelectEditAsset,
  setSelectExpandAsset,
  setSelectShareAsset,
  setSelectItem,
  addFavoriteAsset,
  removeFavoriteAsset,
  setkeyboardEnabled,
  showPermission,
  setKeyCollection,
  showComment,
  iconCommentsPrivateNavbar,
  showHideVersions,
  manageListComment,
  setQtyVersions,
  commentSelectedItem, // se utilizó alias
  handleShowNewVersionAsset,
  cleanWasDartUpdated,
  getUsersToMention,
  individualSelectItem,
  setSelectedFolderExplore
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(CollectionMiddleView))
);
